import React, { Component } from 'react'
import RichText from '../Form/RichText'
import { email } from '../Form/validators'
import { withSettings } from '../withSettings'

@withSettings
export default class EmailDefaults extends Component {
  state = {}

  componentDidMount() {
    this.props.registerDataHandler(data => this.props.setSettingsAt('email.defaults', data))

    this.props.registerValidations([
      { field: 'reply_to_email', validate: email, message: 'Reply to email is not valid.' }
    ])
  }

  render() {
    const { reply_to_name, email_signature } = this.props.getSettingsAt('email.defaults')
    const dynamicFields = this.props.getDynamicFieldsFor('defaults')

    return (
      <div>
        <div className="form-section">
          <label>Name</label>
          <p className="muted">
            The name that will appear on all emails sent to leads.
          </p>
          <input name="reply_to_name" defaultValue={reply_to_name} />
        </div>

        <div className="form-section">
          <label>Email Signature</label>
          <p className="muted">
            {`You can use this email signature anywhere you use the {{email_signature}} template tag.`}
          </p>
          <RichText name="email_signature" defaultValue={email_signature}  dynamicFields={dynamicFields} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Email/Defaults.js